import { styled } from 'styled-components';
const StyledInnerListItem = styled.div.withConfig({
  componentId: "aui__sc-jwxcg9-0"
})(["margin-top:0.25rem;"]);
export { StyledInnerListItem };